import * as React from 'react';
import { getBasePath } from '../../../utils/browser';

// FIXME: ToolIconButtonのコピペ実装

type ButtonPosition = 'start' | 'end';

interface ToolbarItemScrollerButtonProps {
  readonly onHold: () => void;
  readonly vertical: boolean;
  readonly position: ButtonPosition;
  readonly href?: string;
  readonly style?: React.CSSProperties;
  readonly title?: string;
  readonly ariaLabel?: string;
  readonly disabled?: boolean;
  readonly margin?: boolean;
}

interface ToolbarItemScrollerButtonState {
  readonly isHold: boolean;
  readonly hovered: boolean;
}

class ToolbarItemScrollerButton extends React.PureComponent<
  ToolbarItemScrollerButtonProps,
  ToolbarItemScrollerButtonState
> {
  private readonly baseDir: string;
  private rAFID: number | null = null;

  public constructor(props: ToolbarItemScrollerButtonProps) {
    super(props);
    this.state = { isHold: false, hovered: false };
    this.baseDir = getBasePath();
  }

  private handleHoldStart = (ev: React.SyntheticEvent) => {
    ev.preventDefault();
    this.setState({ isHold: true });
  }

  private handleHoldEnd = () => {
    this.setState({ isHold: false });
  }

  private initHold = () => {
    if (this.rAFID !== null) {
      window.cancelAnimationFrame(this.rAFID);
    }
  }

  private holdHandler = (): void => {
    if (!this.props.disabled && this.props.onHold !== undefined) {
      this.props.onHold();
    }
    this.rAFID = window.requestAnimationFrame(this.holdHandler);
  }

  public componentDidUpdate() {
    this.initHold();
    if (this.state.isHold) {
      this.holdHandler();
    }
  }

  public componentWillUnmount() {
    this.initHold();
  }

  public render() {
    const {
      vertical, position, href, style, title, ariaLabel, disabled, margin,
    } = this.props;

    const iconButtonStyle: React.CSSProperties = {
      width: vertical ? '48px' : '36px',
      height: vertical ? '36px' : '48px',
      minHeight: vertical ? '36px' : '48px',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'inherit',
      textDecoration: 'none',
      background: 'rgba(0, 0, 0, 0.1)',
      boxSizing: 'border-box',
    };

    if (margin !== false) {
      iconButtonStyle.margin = '8px';
    }

    let rotation = 0;
    if (vertical) {
      rotation += (position === 'end' ? 180 : 0);
    } else {
      rotation += (position === 'end' ? 90 : -90);
    }

    let stateName = 'out';
    if (this.state.hovered) {
      stateName = 'over';
    }
    if (this.state.isHold) {
      stateName = 'selected';
    }
    if (disabled) {
      stateName = 'disable';
    }

    const imgSrc = `${this.baseDir}/images/toolbar-item-scroller/btn_main_up_${stateName}.png`;
    const imgStyle: React.CSSProperties = {
      width: '48px', // 高さを指定すると縦に回して使う時に何故かSafariで正常に描画されないため幅のみ指定する
      transform: `rotateZ(${rotation}deg)`,
    };

    return (
      <a
        style={{ ...iconButtonStyle, ...style }}
        href={href}
        onMouseEnter={() => this.setState({ hovered: true })}
        onMouseLeave={() => this.setState({ hovered: false })}
        onMouseDown={ev => this.handleHoldStart(ev)}
        onTouchStart={ev => this.handleHoldStart(ev)}
        onMouseUp={this.handleHoldEnd}
        onMouseMove={this.handleHoldEnd} // やや強引だが移動でもホールドを終えるようにしている
        onTouchMove={this.handleHoldEnd}
        onTouchEnd={this.handleHoldEnd}
        onTouchCancel={this.handleHoldEnd}
        title={title}
        aria-label={ariaLabel}>
        <img src={imgSrc} style={imgStyle} />
      </a>
    );
  }
}

export default ToolbarItemScrollerButton;
